import { observer } from 'owa-mobx-react';
import React from 'react';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { getDensityModeString, getDensityModeCssClass } from 'owa-fabric-theme';

import {
    shimmerRow,
    personaColumn,
    personaGap,
    contentColumn,
    contentLine1,
    contentGap1,
    contentLine2,
    contentGap2,
    contentLine3,
    contentGap3,
    full,
    compact,
    paddingFirstMessage,
    paddingMessage,
    mailListShimmerContainer,
} from './ShimmerRowSLVV9.scss';

import classnames from 'owa-classnames';

export interface ShimmerRowSLVV9Props {
    isFirstMessage: boolean;
}

const ShimmerRowSLVV9: React.FunctionComponent<ShimmerRowSLVV9Props> = observer(
    function ShimmerRowSLVV9(props: ShimmerRowSLVV9Props) {
        const densityModeString = getDensityModeString();
        const showCircle = densityModeString === 'full';

        const personaColumnWidth = React.useMemo(
            () => ({ width: showCircle ? '5%' : '4%' }),
            [showCircle]
        );
        const contentColumnWidth = React.useMemo(
            () => ({ width: showCircle ? '95%' : '96%' }),
            [showCircle]
        );

        return (
            <div
                className={classnames(
                    getDensityModeCssClass(full, undefined, compact),
                    props.isFirstMessage ? paddingFirstMessage : paddingMessage,
                    mailListShimmerContainer
                )}
            >
                <Skeleton>
                    <div className={shimmerRow}>
                        <div className={personaColumn} style={personaColumnWidth}>
                            <div className={personaGap} />
                            {showCircle && <SkeletonItem shape="circle" size={28} />}
                        </div>
                        <div className={contentColumn} style={contentColumnWidth}>
                            <SkeletonItem className={contentLine1} size={16} />
                            <div className={contentGap1} />
                            <SkeletonItem className={contentLine2} size={16} />
                            <div className={contentGap2} />
                            <SkeletonItem className={contentLine3} size={16} />
                            <div className={contentGap3} />
                        </div>
                    </div>
                </Skeleton>
            </div>
        );
    },
    'ShimmerRowSLVV9'
);

export default ShimmerRowSLVV9;
